<script setup lang="ts">
import { computed } from 'vue'
import Button from 'primevue/button'
import { useTheme } from '@/composables/useTheme'

const { isDark, toggle } = useTheme()
const icon = computed(() => (isDark.value ? 'pi pi-sun' : 'pi pi-moon'))
const ariaLabel = computed(() => (isDark.value ? 'Switch to light theme' : 'Switch to dark theme'))
</script>

<template>
  <Button :icon="icon" severity="secondary" text rounded :aria-label="ariaLabel" @click="toggle" />
</template>
